if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.BodyElement = document.body;
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]'
          ),
          input_curr: this.querySelector('input[name="country_code"]'),
          input_lang: this.querySelector('input[name="locale_code"]'),
          button: this.querySelector('button.js-localization-form-button'),
          closeButton: this.querySelector('.js-localization-close-button'),
          panel: this.querySelector(
            '.localization-form-wrapper:not(.mobile-submenu-localization)'
          ),
          panel_mobile: this.querySelector(
            '.localization-form-wrapper.mobile-submenu-localization'
          ),
          search: this.querySelector('input[name="country_filter"]'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          countrySelector: this.querySelector('.country-selector'),
          countrySelectorList: this.querySelector('.country-selector__list'),
          searchLabel: this.querySelector('.search__label'),
          overlay: this.querySelector('.country-selector__overlay'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));

        this.elements.overlay.addEventListener(
          'click',
          this.hidePanel.bind(this)
        );

        if (this.elements.button) {
          this.elements.button.addEventListener(
            'click',
            this.openSelector.bind(this)
          );
        }

        if (this.elements.search) {
          this.elements.search.addEventListener(
            'keyup',
            this.filterCountries.bind(this)
          );
          this.elements.search.addEventListener(
            'focus',
            this.onSearchFocus.bind(this)
          );
          this.elements.search.addEventListener(
            'blur',
            this.onSearchBlur.bind(this)
          );
          this.elements.search.addEventListener(
            'keydown',
            this.onSearchKeyDown.bind(this)
          );
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener(
            'click',
            this.hidePanel.bind(this)
          );
        }

        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener(
            'click',
            this.resetFilter.bind(this)
          );
          this.elements.resetButton.addEventListener('mousedown', (event) =>
            event.preventDefault()
          );
        }

        this.querySelectorAll('a').forEach((item) =>
          item.addEventListener('click', this.onItemClick.bind(this))
        );
      }

      hidePanel() {
        this.elements.overlay.classList.add('hidden');

        if (this.elements.button) {
          this.elements.button.setAttribute('aria-expanded', 'false');
        }

        this.elements.panel.classList.add('translate-x-full');
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }

        this.BodyElement.classList.remove('lang-is-open');
        this.BodyElement.classList.remove('overflow-hidden-mobile');
        document
          .querySelector('.menu-drawer')
          .classList.remove('country-selector-open');
        this.header.preventHide = false;
        this.header.classList.remove('shopify-section-header-hidden');
        this.handleToggleAnnouncementBarIndex(true);
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex(
          (item) => item === document.activeElement
        );
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0
                ? focusableItems[focusedItemIndex - 1]
                : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1
                ? focusableItems[focusedItemIndex + 1]
                : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex(
            (item) => item === document.activeElement
          );
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute(
              'aria-activedescendant',
              focusableItems[focusedItemIndex].id
            );
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false')
              return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true')
              return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const form = this.querySelector('form');
        if (event.currentTarget.dataset.formType === 'currency') {
          this.elements.input_curr.value = event.currentTarget.dataset.value;
        } else if (event.currentTarget.dataset.formType === 'language') {
          this.elements.input_lang.value = event.currentTarget.dataset.value;
        }
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.classList.remove('translate-x-full');
        this.elements.button.setAttribute(
          'aria-expanded',
          (
            this.elements.button.getAttribute('aria-expanded') === 'false'
          ).toString()
        );

        if (!this.BodyElement.classList.contains('overflow-hidden-tablet')) {
          this.BodyElement.classList.add('overflow-hidden-mobile');
        }
        this.BodyElement.classList.add('lang-is-open');

        if (this.elements.overlay.classList.contains('hidden')) {
          this.elements.overlay.classList.remove('hidden');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
          this.header.classList.add('shopify-section-header-hidden');
        }
        document
          .querySelector('.menu-drawer')
          .classList.add('country-selector-open');

        this.ignoreClick = true;
        setTimeout(() => {
          this.ignoreClick = false;
        }, 200);

        document.addEventListener('click', this.handleClickOutside.bind(this));
        this.handleToggleAnnouncementBarIndex();
      }

      handleClickOutside(event) {
        if (
          !this.contains(event.target) &&
          !this.elements.button.contains(event.target)
        ) {
          this.hidePanel();
          document.removeEventListener(
            'click',
            this.handleClickOutside.bind(this)
          );
        }
      }

      closeSelector(event) {
        if (event.target.classList.contains('country-selector__overlay')) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      handleToggleAnnouncementBarIndex(force = false) {
        const announcementBar = document?.getElementById('js-announcement-bar');

        if (!announcementBar) {
          return null;
        }

        announcementBar.classList.toggle('z-indexAnnouncementBar', force);
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryElement = item.querySelector('.country');
          if (countryElement) {
            const countryName = this.normalizeString(
              countryElement.textContent
            );
            if (countryName.indexOf(searchValue) > -1) {
              item.parentElement.classList.remove('hidden');
              visibleCountries++;
            } else {
              item.parentElement.classList.add('hidden');
              visibleCountries--;
            }
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.countrySelectorSearchCount.replace(
              '[count]',
              visibleCountries
            );
        }
        if (
          this.elements.countrySelector &&
          this.elements.countrySelectorList
        ) {
          this.elements.countrySelector.scrollTop = 0;
          this.elements.countrySelectorList.scrollTop = 0;
        }
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements?.searchIcon?.classList.add(
          'country-filter__search-icon--hidden'
        );
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements?.searchIcon?.classList.remove(
            'country-filter__search-icon--hidden'
          );
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
